// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import APIIntegrations from 'Components/APIIntegrations/APIIntegrations';

const StyledAPIIntegrationsPage = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const APIIntegrationsPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let apiIntegrationsPageClassNames = bodyAttributes?.class || '';
  if (!apiIntegrationsPageClassNames.includes('APIIntegrationsPage')) {
    apiIntegrationsPageClassNames += 'APIIntegrationsPage';
  }

  return (
    <>
      <Helmet>
        <body className={ apiIntegrationsPageClassNames } />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.apiIntegrations') }</title>
      </Helmet>
      <StyledAPIIntegrationsPage theme={ theme } className="grid-container">
        <AccountSideMenu />
        <APIIntegrations />
      </StyledAPIIntegrationsPage>
    </>
  );
});

APIIntegrationsPage.displayName = 'APIIntegrationsPage';

export default APIIntegrationsPage;
